import Wearables from './Wearables'
export default Wearables
